import './App.css';
import Navbar from './Navbar'
import About from './About'
import Textform from './Textform'
import { useState } from "react";

function App(props) {

  let Darkscss = {
    mode: "dark",
    color: "White",
    backgroundColor: "rgb(33, 33, 36)",
  }

  let Lightcss = {
    mode: "light",
    color: "rgb(33, 33, 36)",
    backgroundColor: "white",
  }

  const [mystyle, StyleToggle] = useState(Lightcss);

  const HandleToggle = () => {
    if (mystyle.mode === "light") {
      StyleToggle(Darkscss);
    }
    else {
      StyleToggle(Lightcss);
    }
  }


  return (
    <main className='main' style={mystyle}>
      <div>
        <Navbar heading="Text App" toggle={HandleToggle} style={mystyle} />
      </div>
      <div className="container my-3">
        <Textform title="Enter your text to analyze" />
      </div>
      <div className='my-5'>
        <About />
      </div>
    </main>
  );
}

export default App;
